export const versionWithoutBuildNumber = (
  version: string | null,
): string | null => (version === null ? null : version.replace(/\+.*/, ''));
